export default {
  methods: {
    /**
     * 检测滑块验证参数
     * @param {*} params 
     */
    checkNcParams(params) {
      if (!params && this.ncParams) {
        params = this.ncParams
      }
      if (!params.token || !params.session || !params.sig) {
        this._warning('请滑动滑块')
        return false
      }
      return {
        nc_token: params.token,
        nc_session_id: params.session,
        nc_sig: params.sig
      }
    },
    /**
     * 验证常用的表单字段
     * @param {username,password,repassword,sms_code}, params 
     */
    checkUser(params) {
      if (typeof params.username != 'undefined' && !params.username) {
        this._warning('请输入用户名')
        return false
      }
      if (typeof params.password != 'undefined') {
        if (!params.password) {
          this._warning('请输入密码')
          return false
        }
        if (!/^.{8,20}$/.test(params.password)) {
          this._warning('密码需要8，20位');
          return false;
        }
        // if (!/(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{8,20}/.test(params.password)) {
        //   this._warning('密码过于简单:，密码需要数字、小写字母、大写字母、符号中至少两种，且不少于8位')
        //   return false
        // }

      }
      if (typeof params.repassword != 'undefined' && params.repassword != params.password) {
        this._warning('两次密码不一致')
        return false
      }
      if (typeof params.sms_code != 'undefined') {
        if (!params.sms_code) {
          this._warning('请输入短信验证码')
          return false
        }
        if (!/^[0-9]{4,6}$/.test(params.sms_code)) {
          this._warning('短信验证码格式错误')
          return false
        }
      }
      return true
    },
    /**
     * 验证手机号
     * @param {*} phone 
     */
    checkMobile(phone) {
      if (!(/^1[3456789]\d{9}$/.test(phone))) {
        this._warning('手机号有误')
        return false
      } else {
        return true
      }
    },

    /**
     * 验证密码复杂度
     * @param password
     * @param msg
     * @returns {boolean}
     */
    checkPassword(password, msg='密码过于简单:，密码需要数字、小写字母、大写字母、符号中至少三种') {
      let typeNum = 0
      if(/[a-z]/.test(password)){
        typeNum++
      }
      if(/[A-Z]/.test(password)){
        typeNum++
      }
      if(/\d/.test(password)){
        typeNum++
      }
      if(/[\W_]/.test(password)){
        typeNum++
      }
      if(typeNum < 3){
        this._warning(msg);
        return false;
      }else{
        return true;
      }
    },

    /**
     * 快速 warning
     * @param {string} msg 
     */
    _warning(msg) {
      this.$message({
        message: msg,
        type: 'warning'
      })
    },
    _success(msg) {
      this.$message({
        message: msg,
        type: 'success'
      })
    }
  }
}